import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Field, reduxForm, submit } from 'redux-form'
import Dialog, { DialogTitle, DialogContent, DialogActions } from 'material-ui/Dialog'
import Divider from 'material-ui/Divider'
import Button from 'material-ui/Button'

import SimpleTextField from './group'
import ValidationErrors from '../../users/validation_errors'
import { togglePasswordDialog, updatePassword } from 'modules/users/current/passwords'
import errorsSelector from 'selectors/errors'
import currentUserSelector from 'selectors/current_user'

const Form = ({ handleSubmit, current_user }) => (
  <form className="disable-submit-event" onSubmit={handleSubmit}>
    <fieldset>
      {!current_user.uses_default_password && (
        <Field
          component={SimpleTextField}
          label="Current password"
          name="current_password"
          type="password"
          required
          autoComplete="off"
          className="form-control-mui"
        />
      )}
      <Field
        component={SimpleTextField}
        label="Password"
        name="password"
        type="password"
        required
        autoComplete="off"
        className="form-control-mui"
      />
      <Field
        component={SimpleTextField}
        label="Confirm password"
        name="password_confirmation"
        type="password"
        required
        autoComplete="off"
        className="form-control-mui"
      />
    </fieldset>
  </form>
)

const ChangePassword = ({ togglePasswordDialog, submit, errors, open }) => (
  <Dialog open={open} onClose={() => togglePasswordDialog()} id="modal-change-password" fullWidth>
    <DialogTitle>Change password</DialogTitle>
    <DialogContent>
      <ValidationErrors errors={errors} />
      <ReduxForm />
    </DialogContent>
    <Divider light />
    <DialogActions>
      <Button color="primary" onClick={() => submit('profile_edit_password')}>
        Send
      </Button>
      <Button onClick={() => togglePasswordDialog()}>Close</Button>
    </DialogActions>
  </Dialog>
)

const mapStateToProps = state => ({
  open: state.users.current.passwords.dialog_opened,
  errors: errorsSelector('users.current.passwords', 'validation_error')(state),
  current_user: currentUserSelector(state)
})

const mapDispatchToProps = dispatch =>
  bindActionCreators({ togglePasswordDialog, updatePassword, submit }, dispatch)

const ReduxForm = connect(mapStateToProps, mapDispatchToProps)(
  reduxForm({
    form: 'profile_edit_password',
    onSubmit: (props, dispatch, { togglePasswordDialog, updatePassword }) =>
      updatePassword(props).then(() => togglePasswordDialog())
  })(Form)
)

export default connect(mapStateToProps, mapDispatchToProps)(ChangePassword)



// WEBPACK FOOTER //
// ./src/containers/pages/profile/edit/change_password.js